<!-- eslint-disable camelcase -->
<script setup>
import { onMounted, ref, watch, nextTick } from "vue"
import axios from "@/utils/axios"
import { toast } from "vue3-toastify"
import "vue3-toastify/dist/index.css"
import { useLoading } from "vue-loading-overlay"
import loaderData from "@/utils/loader-data"
import { useRouter } from "vue-router"
import ContactTabAccounts from "@/components/contacts/tabs/ContactTabAccounts.vue"
import ContactTabTransactions from "@/components/contacts/tabs/ContactTabTransactions.vue"
import ContactTabPositions from "@/components/contacts/tabs/ContactTabPositions.vue"
import ContactTabSecurities from "@/components/contacts/tabs/ContactTabSecurities.vue"
import ContactTabGeneral from "@/components/contacts/tabs/ContactTabGeneral.vue"
import ContactTabCustomFields from "@/components/contacts/tabs/ContactTabCustomFields.vue"

const router = useRouter()
const $loading = useLoading(loaderData)
const route = useRoute("contacts-view-id")
const currentTab = ref(0)

const contactData = ref({
  first_name: "",
  last_name: "",
  phone: "",
  email: "",
  notes: "",
  organization_id: "",
  branch_id: "",
  household_id: "",
  social_security_number: "",
  date_of_birth: '',
  values: [],
  client: null,
})

const getContactData = function () {
  let id = route.params.id
  let loader = $loading.show()
  let url = `/contacts/${id}?show=all`
  axios
    .get(url)
    .then(response => {
      if (response.status == "success") {
        contactData.value = {
          ...contactData.value,
          ...response.data.contact,
        }
      } else {
        toast.error(response.message, {
          autoClose: 2000,
        })
      }
    })
    .catch(error => {
      loader.hide()
    })
    .finally(() => {
      loader.hide()
    })
}

// RELATED TO FTP DATA AS CLIENT's MASTER ACCOUNT
const getClientData = async function () {
  let id = route.params.id
  let url = `/contacts/${id}/client`
  try {
    const { data } = await axios.get(url)

    contactData.value.client = data
  } catch (e) {

  }
}

onMounted(async () => {
  getContactData()
  getClientData()
})

const discardChanges = () => {
  router.push({ name: "contacts-list" })
}

const editContact = () => {
  router.push({ name: "contacts-id", params: { id: contactData.value.id } })
}

const tabs = ref([
  { value: 'general', title: 'General', component: ContactTabGeneral },
  { value: 'customFields', title: 'Additional', component: ContactTabCustomFields },
  { value: 'accounts', title: 'Accounts', component: ContactTabAccounts },
  { value: 'positions', title: 'Positions', component: ContactTabPositions },
  { value: 'trades', title: 'Trades', component: ContactTabTransactions },

  // { value: 'securities', title: 'Securities', component: ContactTabSecurities, requires: 'client' },
])

definePage({ meta: { requiresAuth: true } })
</script>

<template>
  <div>
    <div>
      <!-- 👉 Header  -->
      <div class="d-flex justify-space-between align-center flex-wrap gap-y-4 mb-6">
        <div>
          <div class="d-flex gap-2 align-center mb-2 flex-wrap">
            <h2>
              <strong class="oswald">Contact Details</strong>
            </h2>
          </div>
          <div>
            <span class="lato-light">
              {{ new Date(contactData.created_at).toLocaleString('en-US', {
                dateStyle: 'long', timeStyle:
                  'short'
              }) }}
            </span>
          </div>
        </div>
        <div class="d-flex gap-4">
          <VBtn
            variant="tonal"
            color="dark"
            @click="discardChanges"
          >
            Back
          </VBtn>

          <VBtn
            variant="tonal"
            color="primary"
            @click="editContact"
          >
            Edit Contact
          </VBtn>
        </div>
      </div>
      <!-- 👉 Customer Profile  -->
      <VRow>
        <VCol
          cols="12"
          md="5"
          lg="4"
        >
          <VRow>
            <!-- SECTION Customer Details -->
            <VCol cols="12">
              <VCard>
                <VCardText class="text-center pt-15">
                  <!-- 👉 Avatar -->
                  <VAvatar
                    rounded
                    :size="100"
                    color="primary"
                    variant="tonal"
                  >
                    <!-- <VImg v-if="props.customerData.avatar" :src="props.customerData.avatar" /> -->
                    <span class="text-5xl font-weight-medium">
                      {{ contactData.first_name }}
                      <!-- {{ avatarText(contactData.name) }} -->
                    </span>
                  </VAvatar>

                  <!-- 👉 Customer fullName -->
                  <h2 class="mt-4">
                    <strong class="oswald">{{ contactData.first_name + " " + contactData.last_name }}</strong>
                  </h2>
                  <span class="text-sm lato-light">{{ contactData.email }}</span>
                </VCardText>
              </VCard>
            </VCol>
            <!-- !SECTION -->
          </VRow>
        </VCol>
        <VCol
          cols="12"
          md="7"
          lg="8"
        >
          <VTabs
            v-model="currentTab"
            class="v-tabs-pill mb-3 disable-tab-transition"
          >
            <template 
              v-for="tab in tabs"
              :key="tab.value"
            >
              <VTab
                v-if="!tab.requires || !!contactData[tab.requires]"
                :text="tab.title"
                :value="tab.value"
              />
            </template>
          </VTabs>
          <VWindow
            v-model="currentTab"
            class="disable-tab-transition"
            :touch="false"
          >
            <template 
              v-for="tab in tabs"
              :key="tab.value"
            >
              <VWindowItem
                v-if="!tab.requires || !!contactData[tab.requires]"
                :value="tab.value"
              >
                <component
                  :is="tab.component"
                  :contact="contactData"
                />
              </VWindowItem>
            </template>
          </VWindow>
        </VCol>
      </VRow>
    </div>
  </div>
</template>
